import React from 'react';

import { AiOutlineLoading3Quarters } from "react-icons/ai";
import { ButtonPrimary, ButtonSecondary, LinkPrimary } from './styles';

const variants = {
  buttonPrimary: ButtonPrimary,
  linkPrimary: LinkPrimary,
  buttonSecondary: ButtonSecondary,
};

function Button({ loading = false, text, component, variant, ...props }) {

  const ComponentForRendering = component || variants[variant] || 'button';

  return (
    <ComponentForRendering {...props}>
      {loading ? <AiOutlineLoading3Quarters size={18} className="rotating" /> : text}
    </ComponentForRendering>
  )
}

//className="login__btn login__btn--biggest" type="submit"

export default Button;


/**
 * 
 * .login__btn {
    
  }

  .login__btn--smaller {
    min-width: 33px;
    width: 10%;
    padding: 9px 0;
    font-size: 11px;
    margin-left: auto;
    position: absolute;
    top: 0;
    right: 0;
  }

  .login__btn--biggest {
    width: 100% !important;
    padding: 11px 0;
    font-size: 14px;
    margin: 0 auto 69px auto;
  }

  .login__btn-secondary {
    border-radius: 3px;
    color: #CB3D42;
    font-weight: 400;
    text-align: center;
    font-family: Montserrat, sans-serif;
    border: 1px solid #CB3D42;
    width: 144px;
    padding: 11px 0;
    cursor: pointer;
    text-decoration: none;
  }

  .login__form .login__btn--biggest {
    justify-content: center;
    display: flex;
    height: 40px;
    align-items: center;
    font-size: 14px;
    margin: 0 !important;
  }

    button.login__btn.btn__outlined {
    border: 1px solid #CB3D42;
    background-color: transparent;
    color: #CB3D42;
  }

  a.login__btn--biggest {
      text-decoration: none;
  }

  .login__form .login__btn--biggest {
    max-width: 100%;
  }
 */
